import React from 'react';

export const PlayFilled = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M18.66 14.39 8.58 20.55A3.01 3.01 0 0 1 4 18V6a3.01 3.01 0 0 1 4.58-2.55L18.66 9.6a2.8 2.8 0 0 1 0 4.78Z"
      />
    </svg>
  );
};
